import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab"]
  static values = {
    view: { type: String, default: "all" }
  }

  connect() {
    this.#applyView()
    this.#updateTabStyles()
  }

  setView(event) {
    this.viewValue = event.params.view
  }

  viewValueChanged() {
    this.#applyView()
    this.#updateTabStyles()
  }

  // Mentions-only hides every non-matched row, and every fold toggle that groups
  // nothing but non-matched siblings — with those siblings gone there's nothing
  // left for it to expand into. A depth-cap fold can hold a mention, so that one
  // stays. Toggling `display` (not the `<details>` open attribute) so prior fold
  // state is untouched when switching back.
  #applyView() {
    const mentionsOnly = this.viewValue === "mentions"
    this.element.querySelectorAll("[data-comment-block]").forEach(el => {
      const isMatch = el.dataset.isMatch === "true"
      const isOp = el.dataset.isOp === "true"
      const hasMatchInside = el.querySelector("[data-match-el]") !== null
      el.style.display = mentionsOnly && !isMatch && !isOp && !hasMatchInside ? "none" : ""
    })
    this.element.querySelectorAll("[data-fold-toggle]").forEach(el => {
      el.style.display = mentionsOnly && el.dataset.hasMatch !== "true" ? "none" : ""
    })
  }

  #updateTabStyles() {
    if (!this.hasTabTarget) return
    this.tabTargets.forEach(tab => {
      const active = tab.dataset.commentViewViewParam === this.viewValue
      tab.classList.toggle("text-ink", active)
      tab.classList.toggle("border-brand", active)
      tab.classList.toggle("text-ink-slate", !active)
      tab.classList.toggle("border-transparent", !active)
    })
  }
}
